import React from 'react'
import { colors, Text } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { type SnowflakeColumn } from '../PublishToSnowflakeForm'
import { Input } from '../../../shared-styled-components/SharedStyledComponents'

interface ColumnMappingRowProps {
  column: SnowflakeColumn
  onChange: (column: SnowflakeColumn) => void
  disabled: boolean
}

const Cell = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const ColumnMappingRow: React.FC<ColumnMappingRowProps> = ({ column, onChange, disabled }) => {
  const isMappingRequired = column.nonNull && !column.defaultValue && !column.isPrimaryKey
  return (
    <>
      <Cell>{column.name}</Cell>
      <Cell>{column.type}</Cell>
      <Cell>{column.nonNull ? 'Yes' : 'No'}</Cell>
      <Cell>
        {column.defaultValue || (
          <div style={{ color: colors.GRAYSCALE.X30 }}>
            <Text size="small" weight="semibold">
              None
            </Text>
          </div>
        )}
      </Cell>
      <Cell>{column.isPrimaryKey ? 'Yes' : 'No'}</Cell>
      <Cell>
        {disabled ? (
          <div style={{ justifySelf: 'flex-start' }}>
            <Text>{column.campField}</Text>
          </div>
        ) : (
          <Input
            style={{ width: '100%' }}
            value={column.campField || ''}
            onChange={e => onChange({ ...column, campField: e.target.value })}
            placeholder="CAMP field"
            error={isMappingRequired && !column.campField}
          />
        )}
      </Cell>
    </>
  )
}

export default ColumnMappingRow
